import React, {useEffect, useState} from "react";
import "./chat-feedback.less";
import {useDispatch} from "react-redux";
import {ChatFeedbackProps} from "../../types/chat-feedback-types";
import {submitFeedbackAction} from "../../actions/chat-common-actions";
import {CONFIG} from "../../common/config";
import {isJson} from "../../utils/jsonVerification";

const ChatFeedback: React.FC<ChatFeedbackProps> = (props: ChatFeedbackProps) => {
    const [param, setParam] = useState<any>({});
    const [disable, setDisable] = useState(false);
    const [mandatoryList, setMandatoryList] = useState<string[]>([""]);
    const [currentStar, setCurrentStar] = useState<any>({});
    const isHistoryMsg = props.isHistoryMsg;
    const dispatch = useDispatch();
    const params = (props.param && isJson(props.param) && JSON.parse(props.param).items) ? JSON.parse(props.param) : JSON.parse(CONFIG.FEEDBACK_DEFAULT_PARAM);
    const surveyId = (props.param && isJson(props.param) && JSON.parse(props.param).surveyId) ? JSON.parse(props.param).surveyId : params.surveyId;
    let items = params.items;

    useEffect(() => {
        if (items) {
            items.sort(function (a, b) {
                a = a ? a : -1;
                b = b ? b : -1;
                return a.order - b.order;
            });
        }
        const nextMandatoryList = items
            .filter(item => item.mandatory)
            .map(item => item.field);
        setMandatoryList(nextMandatoryList);
    }, []);

    const changeParam = (data: any) => {
        if (data) {
            const field = Object.keys(data)[0];
            setMandatoryList((prevMandatoryList) => {
                const nextMandatoryList = prevMandatoryList.filter(item => item !== field);
                return data[field] === '' ? [...nextMandatoryList, field] : nextMandatoryList;
            });
        }
        setParam((prevParam) => ({...prevParam, ...data}));
    }


    const submit = () => {
        setDisable(true);

        const data: any = {
            ...param,
            convId: props.convId,
            surveyId: surveyId,
            actionCode: props.actionCode
        };
        dispatch(submitFeedbackAction(data));
    }

    return (
        <>
            <div className="chat-feedback-main" data-testid="chatFeedback">
                {
                    items && items.map((item, index) => {
                        return (
                            item.type === "Rating" ?
                                <Rating key={index} title={item.title} size={5} starType={item.starType}
                                        disable={disable} onClick={(num) => {
                                    setCurrentStar({[item.id]: num - 1})
                                    changeParam({[item.field]: {[num]: {selected: true}}});
                                }}></Rating> : item.type === "Comment" ?
                                <Comment isHistoryMsg={isHistoryMsg} combineWith={item.combineWith}
                                         currentStar={currentStar} key={index} title={item.title}
                                         titleList={item.titleList} disable={disable} onChange={(value) => {
                                    changeParam({[item.field]: value});
                                }}></Comment>
                                : item.type === "RadioGroup" ?
                                    <RadioGroup key={index} title={item.title} disable={disable}
                                                values={item.values} onClick={(value, subject) => {
                                        changeParam({
                                            [item.field]: {[value]: {selected: true}},
                                            "feedbackCategoryName": subject
                                        });
                                    }}></RadioGroup> : <></>
                        )
                    })
                }
                <div style={{display: (isHistoryMsg || disable) ? "none" : "block"}}>
                    <button onClick={() => {
                        submit();
                    }} className={mandatoryList.length <= 0 ? "chat-feedback-submit" : "chat-feedback-submit-disable"}
                            disabled={mandatoryList.length > 0}>Submit
                    </button>
                </div>
            </div>
        </>
    )
};


interface CommentProps {
    title?: string;
    disable: boolean;
    currentStar: any;
    combineWith?: number;
    titleList?: string[];
    onChange?: (value: string) => void;
    isHistoryMsg: boolean;
}

const Comment: React.FC<CommentProps> = (props: CommentProps) => {
    const [desc, setDesc] = useState<string>("");

    return (
        <>
            <div className="chat-feedback-desc-wrap">
                {(props.combineWith && props.titleList && Array.isArray(props.titleList) && props.titleList[props.currentStar[props.combineWith]]) ? (
                        <p className="chat-feedback-desc-item">{props.titleList[props.currentStar[props.combineWith]]}</p>) :
                    <p className="chat-feedback-desc-item"></p>
                }
                <textarea disabled={(props.isHistoryMsg || props.disable)} data-testid="feeback-textarea"
                          maxLength={800}
                          className="chat-feedback-desc" onChange={(value) => {
                    setDesc(value.target.value);
                    props.onChange && props.onChange(value.target.value);
                }}></textarea>
                <span className="chat-feedback-desc-count">{desc.length}/800 characters</span>
            </div>
        </>
    )

}

interface RadioGroupProps {
    title?: string;
    disable: boolean;
    values: any[];
    onClick?: (event: number, subject: string) => void;
}

const RadioGroup: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {

    const [subject, setSubject] = useState("");

    return (
        <>
            <p className="subject-btn-group-title">{props.title}</p>
            <div hidden={!props.values} className="subject-btn-group">
                {props.values && props.values.map((elem, index) => {
                    return (
                        <button key={index}
                                type="button"
                                disabled={props.disable}
                                className={elem.value === subject ? "subject-btn btn btn-selected" : "subject-btn btn btn-default"}
                                onClick={() => {
                                    setSubject(elem.value);
                                    props.onClick && props.onClick(elem.id, elem.value);
                                }}
                        >
                            {elem.value}
                        </button>
                    )
                })}
            </div>
        </>
    )
}

interface RatingProps {
    starType?: string;
    title?: string;
    size?: number;
    disable?: boolean;
    onClick?: (index: number) => void;
}

const Rating: React.FC<RatingProps> = (props: RatingProps) => {

    const [hoverStarNum, setHoverStarNum] = useState(0);
    const [starNum, setStarNum] = useState(0);
    const size = props.size;
    let dom = [];
    for (let i = 1; i <= size; i++) {
        dom.push(i);
    }
    const onClick = (num: number) => {
        props.onClick && props.onClick(num);
    }

    return (
        <div className="rating-wrap">
            <p className="chat-feedback-rate-desc">{props.title ? props.title : 'How would you rate this conversation?'}</p>
            <div className="rating-content">
                <div className="rating-main">
                    {dom.map((number) => {
                        return (
                            <button
                                type="button"
                                data-testid="rating-click"
                                key={number}
                                disabled={props.disable}
                                className={props.disable ? "rating-star-disable" : "rating-star"}
                                onClick={() => {
                                    setStarNum(number);
                                    onClick(number);
                                }}
                                onMouseEnter={() => {
                                    setHoverStarNum(number);
                                }}
                                onMouseLeave={() => {
                                    setHoverStarNum(0);
                                }}
                            >
                                <svg width="31" height="29" viewBox="0 0 31 29" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M13.5979 1.8541C14.1966 0.0114784 16.8034 0.0114794 17.4021 1.8541L19.5413 8.43769C19.809 9.26174 20.5769 9.81966 21.4434 9.81966H28.3658C30.3032 9.81966 31.1088 12.2989 29.5413 13.4377L23.941 17.5066C23.24 18.0159 22.9467 18.9186 23.2145 19.7426L25.3536 26.3262C25.9523 28.1689 23.8433 29.7011 22.2759 28.5623L16.6756 24.4934C15.9746 23.9841 15.0254 23.9841 14.3244 24.4934L8.72409 28.5623C7.15666 29.7011 5.0477 28.1689 5.64641 26.3262L7.78555 19.7426C8.0533 18.9186 7.75998 18.0159 7.059 17.5066L1.45867 13.4377C-0.108762 12.2989 0.69679 9.81966 2.63424 9.81966H9.55664C10.4231 9.81966 11.191 9.26174 11.4587 8.43769L13.5979 1.8541Z"
                                        fill={(hoverStarNum || starNum) >= number ? "#FF9901" : "#E2E7EC"}/>
                                </svg>
                            </button>)
                    })}
                </div>
                <div className="chat-feedback-default-msg"
                     style={{display: props.starType === 'starStyle1' ? "flex" : "none"}}>
                    <div>Very Dissatisfied</div>
                    <div>Very Satisfied</div>
                </div>
                <div className="chat-feedback-msg" hidden={props.starType && props.starType !== 'starStyle2'}>
                    <span hidden={!((hoverStarNum || starNum) === 1)}>Poor</span>
                    <span hidden={!((hoverStarNum || starNum) === 2)}>Fair</span>
                    <span hidden={!((hoverStarNum || starNum) === 3)}>Good</span>
                    <span hidden={!((hoverStarNum || starNum) === 4)}>Very Good</span>
                    <span hidden={!((hoverStarNum || starNum) === 5)}>Excellent</span>
                    <span className="chat-feedback-msg-no-star" hidden={!((hoverStarNum || starNum) === 0)}></span>
                </div>
            </div>
        </div>
    )
}
export default ChatFeedback;